import moment from 'moment';

export default {
    /**
     * Returns moment instance in UTC with current datetime.
     *
     * @returns {moment} Moment instance in UTC with current datetime.
     */
    now: () => moment().utc(),

    /**
     * Returns moment instance in UTC with current date and time set to midnight.
     *
     * @returns {moment} Moment instance in UTC with current date and time set to midnight
     */
    today() {
        return this.now().startOf('day');
    },

    /**
     * Returns moment instance in UTC with given datetime.
     *
     * @param   {string} datetime Datetime to convert.
     * @returns {moment}          Moment instance in UTC with given datetime.
     */
    parse: (datetime) => moment.utc(datetime),
};
